import { Component, OnInit } from "@angular/core";
import { MainLayoutService } from "../../services/main-layout.service";
import { MatRadioChange } from "@angular/material/radio";
import { FacadeService } from "../../service-facade/facade.service";

@Component({
  selector: 'app-funding',
  templateUrl: './funding.component.html',
  styleUrls: ['./funding.component.scss']
})
export class FundingComponent implements OnInit {  
  transferFundsTitle = "Transfer Funds"
  transferFundsDescription = `Link your external bank account and make your first deposit. If you are an existing Bask Customer and would prefer to fund with a Bask Account on an existing linked account, please select "Fund Later" and fund within Online Banking.`
  fundingTerms = `By selecting 'Fund Now' and "Continue", you authorize an SCH debit to your checking or savings account for the amount noted to find you Bask Bank account. Funds may be withdrawn from your account as soon as today. Your funds will be available no later than five business days after ACH transfer is confirmed by us.`

  constructor(
    private mainLayout: MainLayoutService,
    private facade: FacadeService,
  ) {
  }

  ngOnInit(): void {
    this.mainLayout.setPageTitle("Fund Accounts");
  }

  onFundAccountNow(event: MatRadioChange) : void {
    if(event.value) {
        this.facade.markFundAccountNow();
    }
    else {
      this.facade.markFundAccountLater()
    }
  }
}